import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-pantone-icon',
  templateUrl: './tools-pantone.component.html'
})
export class ToolsPantoneComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
